import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from '@/context/AuthContext';
import Header from '@/components/site/Header';
import Footer from '@/components/site/Footer';
import ScrollToTop from '@/components/site/ScrollToTop';
import SeoTags from '@/components/site/SeoTags';
import { Toaster } from '@/components/ui/toaster';

import HomePage from '@/pages/HomePage';
import PlatformPage from '@/pages/PlatformPage';
import IndustriesPage from '@/pages/IndustriesPage';
import ServicesPage from '@/pages/ServicesPage';
import PartnersPage from '@/pages/PartnersPage';
import ContactPage from '@/pages/ContactPage';
import LoginPage from '@/pages/LoginPage';
import RegisterPage from '@/pages/RegisterPage';
import PartnerDashboard from '@/pages/PartnerDashboard';
import UserDashboard from '@/pages/UserDashboard';
import VisoPlatformPage from '@/pages/VisoPlatformPage';
import ShowcasePage from '@/pages/ShowcasePage';
import AboutPage from '@/pages/AboutPage';
import FaqsPage from '@/pages/FaqsPage';
import BlogListPage from '@/pages/BlogListPage';
import BlogPostPage from '@/pages/BlogPostPage';
import IndustryPage from '@/pages/IndustryPage';
import { PrivacyPage, TermsPage, SecurityPage } from '@/pages/LegalPages';
import CareersPage from '@/pages/CareersPage';
import ForgotPasswordPage from '@/pages/ForgotPasswordPage';
import ResetPasswordPage from '@/pages/ResetPasswordPage';
import AccountPage from '@/pages/AccountPage';
import CargoCountingPage from '@/pages/CargoCountingPage';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <ScrollToTop />
          <SeoTags />
          <Header />
          <Routes>
            <Route path="/" element={<HomePage />} />
            {/* Bare parent routes → redirect to a real child so no empty pages get crawled */}
            <Route path="/company" element={<Navigate to="/company/about" replace />} />
            <Route path="/resources" element={<Navigate to="/resources/blog" replace />} />
            <Route path="/legal" element={<Navigate to="/legal/privacy" replace />} />
            <Route path="/partner" element={<Navigate to="/partners" replace />} />
            <Route path="/platform" element={<PlatformPage />} />
            {/* Static path ranks above the dynamic :slug below regardless of
                declaration order (React Router v6's own ranking), but kept
                adjacent for readability. UNLINKED — not in Header's nav, same
                as the source site's convention; noindex is set by the page
                itself (see ShowcasePage.jsx), not here. */}
            <Route path="/platform/showcase" element={<ShowcasePage />} />
            <Route path="/platform/:slug" element={<VisoPlatformPage />} />
            <Route path="/company/about" element={<AboutPage />} />
            <Route path="/company/careers" element={<CareersPage />} />
            <Route path="/resources/faqs" element={<FaqsPage />} />
            <Route path="/resources/blog" element={<BlogListPage />} />
            <Route path="/resources/blog/:slug" element={<BlogPostPage />} />
            <Route path="/industries" element={<IndustriesPage />} />
            <Route path="/industries/:slug" element={<IndustryPage />} />
            <Route path="/legal/privacy" element={<PrivacyPage />} />
            <Route path="/legal/terms" element={<TermsPage />} />
            <Route path="/legal/security" element={<SecurityPage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/partners" element={<PartnersPage />} />
            <Route path="/cargo-counting-use-case" element={<CargoCountingPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/reset-password/:token" element={<ResetPasswordPage />} />
            <Route path="/account" element={<AccountPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/partner/register" element={<RegisterPage isPartner />} />
            <Route path="/partner/dashboard" element={<PartnerDashboard />} />
            <Route path="/dashboard" element={<UserDashboard />} />
            {/* Catch-all: any unknown URL redirects to home so Google never indexes a blank page */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Footer />
          <Toaster />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
